// The calendar's layout, kept on this device (screens/CALENDAR.md, B-569):
// two weeks from Sunday, one week, or the league's own week. A phone, which
// draws a day at a time, reads it only for the day its strip starts on.
//
// THE DEVICE'S, NOT THE ACCOUNT'S: a wide monitor and a tablet held upright
// suit different layouts, so each keeps its own, as the detail level can be.
// Private mode or blocked storage leaves the default, which is what a first
// visit has.

import { useCallback, useState } from 'react';
import { storageKey } from './storage';

export type CalendarLayout = 'two-weeks' | 'one-week' | 'fantasy-week';

export const CALENDAR_LAYOUT_KEY = storageKey('calendar.layout.v1');

const LAYOUTS: readonly CalendarLayout[] = ['two-weeks', 'one-week', 'fantasy-week'];

function stored(): CalendarLayout {
  try {
    const raw = localStorage.getItem(CALENDAR_LAYOUT_KEY);
    return LAYOUTS.find((l) => l === raw) ?? 'two-weeks';
  } catch {
    return 'two-weeks';
  }
}

export function useCalendarLayout(): [CalendarLayout, (next: CalendarLayout) => void] {
  const [layout, setLayout] = useState<CalendarLayout>(stored);
  const choose = useCallback((next: CalendarLayout) => {
    setLayout(next);
    try {
      localStorage.setItem(CALENDAR_LAYOUT_KEY, next);
    } catch {
      // Kept for this visit only: the storage refused it.
    }
  }, []);
  return [layout, choose];
}
